import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

// Send breach notification email
export const sendBreachEmail = createAsyncThunk(
  "breachNotification/sendEmail",
  async (emailData) => {
    try {
      const response = await api.post("/breach-notification/send", emailData);
      return response.data;
    } catch (error) {
      return "Failed to send breach notification email";
    }
  },
);

// Get breach notification template
export const getBreachTemplate = createAsyncThunk(
  "breachNotification/getTemplate",
  async () => {
    try {
      const response = await api.get("/breach-notification/template");
      return response.data;
    } catch (error) {
      return "Failed to fetch breach notification drafts";
    }
  },
);
